var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',[(_vm.label)?_c('span',[_vm._v(_vm._s(_vm.label))]):_vm._e()]),_vm._v(" "),(_vm.src)?_c('woot-thumbnail',{attrs:{"size":"80px","src":_vm.src,"username":_vm.usernameAvatar}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }